import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { SnackbarService } from '../../../shared/components/snackbar/snackbar.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-update-security-stock-by-hierarchy',
  templateUrl: './update-security-stock-by-hierarchy.component.html',
})
export class UpdateSecurityStockByHierarchyComponent implements OnInit, OnDestroy {
  private onDestroy$: Subject<void> = new Subject<void>();
  public form: FormGroup;
  public title = 'Modificar stock de seguridad';
  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    public snackbarService: SnackbarService,
    public dialogRef: MatDialogRef<UpdateSecurityStockByHierarchyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      id: [],
      hierarchyDescription: [{value: "", disabled: true}],
      hierarchyCode: [{value: "", disabled: true}],
      securityStock: [null, [Validators.required, Validators.min(1)]]
    });
  }

  ngOnInit() {
    if (this.data && this.data.length == 1 && this.data[0].id) {
      this.form.controls['id'].setValue(this.data[0].id)
      this.form.controls['securityStock'].setValue(this.data[0].securityStock)
      this.form.controls['hierarchyDescription'].setValue(this.data[0].hierarchyDescription)
      this.form.controls['hierarchyCode'].setValue(this.data[0].hierarchyCode)
    }
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  saveSecurityStock() {
    this.dialogRef.close({
      securityStockForm: this.form.value,
    })
  }

}
